export default "__VITE_ASSET__24d601a6__"